import styled from 'styled-components';

const Label = styled.label`
	font-size: 1.4rem;
	margin-bottom: 5px;
`;

export default Label;
